/**
 * Boot leve vs completo do painel professor.
 * /inscricao/* (landing de turma) não deve carregar charts/PDF/Echo/Vueform no 1º paint.
 */

export function isSalesInscricaoPath(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
    const path = pathname || '';
    return /^\/inscricao(?:\/|$)/.test(path) || /^\/embed\/documento(?:\/|$)/.test(path);
}

export function routeNeedsFullAppPlugins(routeLike) {
    if (!routeLike) {
        return !isSalesInscricaoPath();
    }
    if (routeLike.meta?.layout === 'sales') {
        return false;
    }
    const name = routeLike.name;
    if (
        name === 'inscricao-turma'
        || name === 'inscricao-turma-confirmar'
        || name === 'inscricao-turma-sucesso'
        || name === 'documento-preview-embed'
    ) {
        return false;
    }
    return true;
}

export function routeNeedsFullAppStyles(routeLike) {
    return routeNeedsFullAppPlugins(routeLike);
}

let fullStylesPromise = null;
let salesPluginsPromise = null;
let fullPluginsPromise = null;
let fullPluginsLoaded = false;
let appRef = null;

export function bindAppForDeferredPlugins(app) {
    appRef = app;
}

export function ensureFullAppStyles() {
    if (!fullStylesPromise) {
        fullStylesPromise = import('@/assets/sass/app.scss');
    }
    return fullStylesPromise;
}

/** Bootstrap Modal + SweetAlert — usados na funil de inscrição */
export function ensureSalesPlugins() {
    if (salesPluginsPromise) {
        return salesPluginsPromise;
    }

    salesPluginsPromise = (async () => {
        const [{ default: SwalModule }, bootstrap] = await Promise.all([
            import('sweetalert2'),
            import('bootstrap'),
        ]);

        window.bootstrap = bootstrap;

        const readBrandPrimaryHex = () => {
            if (typeof document === 'undefined') return '#4361ee';
            return (
                getComputedStyle(document.documentElement).getPropertyValue('--brand-primary').trim()
                || '#4361ee'
            );
        };

        window.Swal = SwalModule.mixin({
            buttonsStyling: true,
            confirmButtonColor: '#4361ee',
            didOpen(popup) {
                const primary = readBrandPrimaryHex();
                const confirmBtn = popup.querySelector('.swal2-confirm');
                if (confirmBtn && !confirmBtn.classList.contains('btn-danger')) {
                    confirmBtn.style.setProperty('background-color', primary, 'important');
                    confirmBtn.style.setProperty('border-color', primary, 'important');
                }
                const denyBtn = popup.querySelector('.swal2-deny');
                if (denyBtn) {
                    denyBtn.style.setProperty('background-color', primary, 'important');
                    denyBtn.style.setProperty('border-color', primary, 'important');
                }
            },
        });
    })().catch((err) => {
        salesPluginsPromise = null;
        throw err;
    });

    return salesPluginsPromise;
}

export function ensureFullAppPlugins() {
    if (fullPluginsLoaded) {
        return Promise.resolve();
    }
    if (fullPluginsPromise) {
        return fullPluginsPromise;
    }
    if (!appRef) {
        return Promise.reject(new Error('App Vue ainda não vinculado aos plugins'));
    }

    fullPluginsPromise = (async () => {
        await ensureSalesPlugins();
        await ensureFullAppStyles();

        const [
            Vueform,
            vueformConfig,
            { PerfectScrollbarPlugin },
            Maska,
            VueNouislider,
            { ServerTable, ClientTable },
            vue3JsonExcel,
            VueFormWizard,
            VueEasymde,
            { registerScrollSpy },
        ] = await Promise.all([
            import('@vueform/vueform'),
            import('@/vueform.config'),
            import('vue3-perfect-scrollbar'),
            import('maska'),
            import('vue3-nouislider'),
            import('v-tables-3'),
            import('vue3-json-excel'),
            import('vue3-form-wizard'),
            import('vue3-easymde'),
            import('vue3-scroll-spy/dist/index'),
        ]);

        await Promise.all([
            import('vue3-perfect-scrollbar/style.css'),
            import('vue3-nouislider/dist/vue3-nouislider.css'),
            import('vue3-form-wizard/dist/style.css'),
            import('easymde/dist/easymde.min.css'),
            import('@/assets/sass/components/custom-modal.scss'),
        ]);

        appRef.use(Vueform.default || Vueform, vueformConfig.default || vueformConfig);
        appRef.use(PerfectScrollbarPlugin);
        appRef.use(Maska.default || Maska);
        appRef.use(VueNouislider.default || VueNouislider);
        appRef.use(ClientTable);
        appRef.use(ServerTable);
        appRef.use(vue3JsonExcel.default || vue3JsonExcel);
        appRef.use(VueFormWizard.default || VueFormWizard);
        appRef.use(VueEasymde.default || VueEasymde);
        registerScrollSpy(appRef, { offset: 118 });

        // Echo/realtime só no app autenticado
        import('@/echo').catch(() => {});

        fullPluginsLoaded = true;
    })().catch((err) => {
        fullPluginsPromise = null;
        throw err;
    });

    return fullPluginsPromise;
}
